import { sendOtp, verifyOtp } from './otp'

import {
    meetsAxiosOpen,
    meetsAxiosProtected,
    ohrAxiosOpen,
    ohrAxiosProtected,
} from '../httpInstance/http'

export const getRoomState = roomName =>
    meetsAxiosProtected.get(`/${roomName}/state`)

export const getTwilioToken = ({ roomName, random = false }) =>
    meetsAxiosProtected.post(`/${roomName}/token`, {
        random_name: random,
    })

export const getScheduledClassesForRecording = () =>
    ohrAxiosOpen.get(`/oh_schedules/schedule/today`)

export const getAuthTokens = async ({ phoneNumber, roomName }) => {
    if (roomName) {
        const response = await ohrAxiosOpen(`/oh_users/login/${roomName}`)
        return response.data
    }

    if (phoneNumber) {
        const payload = {
            phone_number: phoneNumber,
        }

        const sendOtpResp = await sendOtp(payload)

        if (!sendOtpResp.data.success) return null

        const verifyOtpResp = await verifyOtp({
            ...payload,
            otp: '123456',
        })

        if (!verifyOtpResp.data.success) return null

        return {
            access_token: verifyOtpResp.data.access_token,
            refresh_token: verifyOtpResp.data.refresh_token,
        }
    }

    throw new Error(`pass in either roomName or phoneNumber`)
}

export const getActiveUsers = roomName =>
    meetsAxiosOpen.get(`/${roomName}/users/active`)

export const checkUserAndRoomStatus = ({ userId, roomName }) =>
    ohrAxiosProtected.get(`/oh_classes/${roomName}/${userId}`)
